<template>
  <div class="app">
    <AgentWidget/>
  </div>
</template>

<script>

export default {
  props: {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    AgentWidget: () => import('@/components/AgentWidget.vue'),
  }
}
</script>

<style scoped>
  .app {
    font-family: Poppins, Montserrat, sans-serif;
    font-size: 14px;
  }
</style>
